import { Backdrop, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../layout/AdminLayout";
import AdminContentCard from "../../../components/Admin/AdminContentCard";
import CreatePostModal from "../../../components/Modals/CreatePostModal";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { getAllPosts } from "../../../redux/dispatchers/posts.dispatcher";

const AdminPosts = () => {
  const dispatch = useDispatch();
  const { allPosts } = useSelector((state) => state.posts);

  const [createPostModal, setCreatePostModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  useEffect(() => {
    dispatch(getAllPosts());
  }, [dispatch]);

  return (
    <AdminLayout
      heading="Posts"
      actionButton={
        <CustomBtn
          text="Add New Post"
          icon
          width="180px"
          height="45px"
          fontSize="16px"
          onClick={() => setCreatePostModal(true)}
        />
      }
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Post Created Successfully"
      />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        {allPosts?.map((post) => (
          <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={post.id}>
            <AdminContentCard item={post} />
          </Grid>
        ))}
      </Grid>

      <CreatePostModal
        open={createPostModal}
        onClose={() => setCreatePostModal(false)}
        setLoading={setLoading}
        setErrorState={setErrorState}
        setSuccess={setSuccess}
        onCreated={() => dispatch(getAllPosts())}
      />
    </AdminLayout>
  );
};

export default AdminPosts;
